import React from 'react';

import {AthleteWidgetEntityPlaceholder} from "../athlete-widget.entity.placeholder";
import styles from "../../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";

export const AthleteWidgetEntitiesDetailsPlaceholder = ({device}) => {
  const {isSmallView} = device;

  const entityProps = {
    device,
    imageSize: isSmallView ? 40 : 56,
    imageMarginTop: isSmallView ? 16 : 0,
    textTopMargin: 4
  }

  return (
    <div className={classNames(styles.details_entities)}>
      <AthleteWidgetEntityPlaceholder {...entityProps}/>
      <div className={classNames(styles.vertical_divider)}/>
      <AthleteWidgetEntityPlaceholder {...entityProps}/>
    </div>
  )
}
